<div class="row align-items-center mt-3">
  <div class="col-md-2">
    <strong>{{ 'signatories' | translate | titlecase }}</strong>
  </div>
  <div class="col">
    <fa-icon size="sm" class="mr-1" [icon]="['far','bell']"></fa-icon>
    <span size="sm"><b>{{ 'reminders' | translate | titlecase }}: </b>{{ signatoryInformation?.reminderFrequency?.value
      }}</span>
  </div>
  <div class="col-md-4 my-3 ml-auto-mobile d-flex justify-content-end">
    <cdx-toolbar-search (onTyping)="onSearch($event)" [value]="valueSearch"
      [placeholder]="'search' | translate | titlecase" [maxlength]="255" [debounceTime]="600">
    </cdx-toolbar-search>
  </div>
</div>
<div class="row">
  <div class="col">
    <div class="table-responsive table__container">
      <table class="table">
        <thead>
          <tr>
            <th *ngIf="isOrdered" scope="col" class="w-60-table text-left">{{ 'order' | translate | titlecase }}</th>
            <th scope="col" class="text-left">{{ 'name' | translate | titlecase }}</th>
            <th scope="col" class="text-left">{{ 'mail' | translate | titlecase }}</th>
            <th *ngIf="settings.language.id === 1" scope="col" class="text-left">{{ 'ssn' | translate | uppercase }}</th>
            <th *ngIf="isSendWhatsapp || isSignFreemium" scope="col" class="text-left">{{ 'contacts.phone' | translate }}</th>
            <th scope="col" class="text-left">{{ 'envelope.signatory.signatureTypeText' | translate }}</th>
            <th scope="col" class="text-left">{{ 'envelope.signatory.subscriberTypeText' | translate }}</th>
            <th *ngIf="(!canSendWhatsApp || isSendWhatsapp) || isSignFreemium" scope="col" class="text-left">{{ 'envelope.signatory.sendingByWhatsapp' | translate }}</th>
          </tr>
        </thead>
        <tbody>
          <ng-container *ngIf="filteredElements.length > 0; else blankSlateSearchTemplate">
            <tr *ngFor="let element of filteredElements; index as i">
              <td *ngIf="isOrdered" class="text-truncate" style="text-align: left;">{{element.order}}</td>
              <td class=" text-truncate" style="text-align: left;">{{element.name}}</td>
              <td class=" text-truncate" style="text-align: left;">{{ element.mail | mailObfuscate }}</td>
              <td *ngIf="settings.language.id === 1" class=" text-truncate" style="text-align: left;">{{element.ssnWithMask}}</td>
              <td *ngIf="isSendWhatsapp || isSignFreemium" class=" text-truncate" style="text-align: left;">{{(element.phoneNumber || element.obfuscatePhoneNumber) | phoneObfuscate}}</td>
              <td class=" text-truncate" style="text-align: left;">{{element.signatureType.value}}</td>
              <td class=" text-truncate" style="text-align: left;">{{ element.signatoryTypeRole.isDefault ? (element.signatoryTypeRole.name | translate) : (element.signatoryTypeRole.name) }}</td>
              <td *ngIf="(!canSendWhatsApp || isSendWhatsapp) && !isSignFreemium" align="center">
                <div class="icon-switch-container d-flex justify-content-left">
                  <fa-icon *ngIf="!canSendWhatsApp && !isSignFreemium" class="fa-fw" [icon]="['fas','crown']"></fa-icon>
                  <cdx-toggle-switch 
                    class="pointerMouse" 
                    [disabled]="element.acceptWhatsApp === false || !(element.phoneNumber || element.obfuscatePhoneNumber) || element.signatureType.id == 3 || !canSendWhatsApp"
                    [toggledOn]="element.sendWhatsApp"
                    (toggle)="needSendWhatsapp($event, element.id)"
                    (click)="handleToggleClick($event)">
                  </cdx-toggle-switch>
                </div>
              </td>
              <td *ngIf="isSignFreemium" align="center">
                <div class="d-flex justify-content-left">
                  <fa-icon class="fa-fw" [icon]="['fas','crown']"></fa-icon>
                  <div (click)="toastWhatsFree()" class="pointerMouse ml-2">
                    <cdx-toggle-switch [disabled]="true"></cdx-toggle-switch>
                  </div>
                </div>
              </td>
            </tr>
          </ng-container>
        </tbody>
      </table>
    </div>
  </div>
</div>

<ng-template #blankSlateSearchTemplate>
  <ng-container>
    <td colspan="8" style="width: 100%;">
      <cdx-blankslate [options]="blankSlateSearch" (buttonClick)="onBlankSlateSearchClick($event)">
        {{'envelope.signatory.blankSlateSearchText' | translate}}</cdx-blankslate>
    </td>
  </ng-container>
</ng-template>
